import script from "./SogDropDownButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogDropDownButton.vue?vue&type=script&setup=true&lang=ts"

import "./SogDropDownButton.vue?vue&type=style&index=0&id=6eb039d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eb039d9"]])

export default __exports__